module.exports = __webpack_public_path__ + "img/header.ba847b8d.svg";